<div class="flex flex-col create-instance-dialog h-100-percent">
  <app-sidenav-header [title]="title" [subtitle]="subtitle"></app-sidenav-header>

  <app-deploy-instance-form #deployInstanceForm [tenantDetails]="tenantDetails" class="overflow-y-auto" [deployment]="deployment" [allInstances]="allInstances" [nonPtlFlow]="nonPtlFlow" [pathToLiveFlow]="pathToLiveFlow"
    [service]="service" [versions]="blueprintsVersionList" [buildNumber]="buildNumber" [blueprint]="blueprint" (changedBuildVersion)="buildVersion($event)" (submitDisable)="submitDisable($event)" (duplicateInstance)="verifyDuplicate($event)"></app-deploy-instance-form>

  <span class="flex-auto"></span>

  <mat-divider class="mb-32"></mat-divider>

  <a href="{{Constants.TERMS_AND_CONDITIONS_URL}}" target="_blank" rel="noopener noreferrer"
  class="body2-font fw-400 terms-and-conditions terms-text">
 {{ 'INSTANCE_SUMMARY.TERMS_AND_CONDITIONS' | transloco }}
</a>
  <div class="flex flex-row gap-4" dir="rtl">
    <button *ngIf="!submitDisableData" class="accent" type="button" (click)="createDeployment()" [ngClass]="{'disabled': !isDuplicateInstance}">{{'BUTTONS.SUBMIT' | transloco}}</button>
    <button class="white" type="button" (click)="sidenavService.closeRightSidenav()">{{'BUTTONS.CANCEL' | transloco}}
    </button>
  </div>
</div>
